"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("@emotion/react/jsx-runtime");
var react_1 = require("@emotion/react");
var react_2 = require("react");
var react_hook_form_1 = require("react-hook-form");
var Styled = __importStar(require("./ApplicationFormItem.styled"));
var Input_component_1 = require("@/components/common/Input/Input.component");
var components_1 = require("@/components");
var Select_component_1 = require("@/components/common/Select/Select.component");
var trash_can_36_svg_1 = __importDefault(require("@/assets/svg/trash-can-36.svg"));
var applicationForm_1 = require("@/types/dto/applicationForm");
var hooks_1 = require("@/hooks");
var options = [
    {
        label: '장문형',
        value: applicationForm_1.QuestionKind.multiLineText,
    },
    {
        label: '단답형',
        value: applicationForm_1.QuestionKind.singleLineText,
    },
];
var ApplicationFormItem = function (_a) {
    var index = _a.index, handleRemoveItem = _a.handleRemoveItem;
    var _b = (0, react_hook_form_1.useFormContext)(), register = _b.register, getValues = _b.getValues, setValue = _b.setValue, watch = _b.watch;
    var _c = __read((0, hooks_1.useToggleState)(!!getValues("questions.".concat(index, ".maxContentLength"))), 2), hasMaxContentLength = _c[0], toggleMaxContentLength = _c[1];
    var questionType = watch("questions.".concat(index, ".questionType"));
    var defaultSelectValue = options.find(function (option) { return option.value === questionType; });
    var readableIndex = index + 1;
    var handleChangeSelect = function (option) {
        setValue("questions.".concat(index, ".questionType"), option.value, {
            shouldDirty: true,
        });
    };
    (0, react_2.useEffect)(function () {
        if (!hasMaxContentLength) {
            setValue("questions.".concat(index, ".maxContentLength"), null, { shouldDirty: true });
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [hasMaxContentLength, index]);
    (0, react_2.useEffect)(function () {
        if (defaultSelectValue) {
            handleChangeSelect(defaultSelectValue);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [defaultSelectValue]);
    return ((0, jsx_runtime_1.jsxs)(Styled.ApplicationFormItemContainer, { children: [(0, jsx_runtime_1.jsxs)(Styled.Col, { children: [(0, jsx_runtime_1.jsxs)(Styled.ApplicationFormItemIndex, { children: [readableIndex, "."] }, void 0), (0, jsx_runtime_1.jsx)(Styled.ApplicationFormItemQuestionInput, __assign({}, register("questions.".concat(index, ".content"), { required: true }), { "$size": Input_component_1.InputSize.md, placeholder: "\uC9C8\uBB38 \uC81C\uBAA9\uC744 \uC785\uB825\uD574\uC8FC\uC138\uC694." }), void 0)] }, void 0), (0, jsx_runtime_1.jsx)(Styled.Col, { children: (0, jsx_runtime_1.jsx)(components_1.InputField, __assign({ "$size": Input_component_1.InputSize.xs }, register("questions.".concat(index, ".description")), { placeholder: "\uC124\uBA85\uC744 \uC785\uB825\uD574\uC8FC\uC138\uC694(\uC120\uD0DD\uC0AC\uD56D\uC785\uB2C8\uB2E4.)" }), void 0) }, void 0), (0, jsx_runtime_1.jsx)(Styled.Col, { children: questionType === applicationForm_1.QuestionKind.multiLineText ? ((0, jsx_runtime_1.jsx)(components_1.Textarea, { placeholder: "\uC7A5\uBB38\uD615 \uD14D\uC2A4\uD2B8\uC785\uB2C8\uB2E4.", disabled: true }, void 0)) : ((0, jsx_runtime_1.jsx)(components_1.Input, { "$size": Input_component_1.InputSize.md, placeholder: "\uB2E8\uB2F5\uD615 \uD14D\uC2A4\uD2B8\uC785\uB2C8\uB2E4.", disabled: true }, void 0)) }, void 0), (0, jsx_runtime_1.jsxs)(Styled.Col, { children: [(0, jsx_runtime_1.jsx)(components_1.Select, { size: Select_component_1.SelectSize.xs, options: options, onChangeOption: handleChangeSelect, defaultValue: defaultSelectValue }, void 0), questionType === applicationForm_1.QuestionKind.multiLineText && ((0, jsx_runtime_1.jsxs)(Styled.MaxContentSizeContainer, { children: [(0, jsx_runtime_1.jsx)(components_1.ToggleButton, { isChecked: hasMaxContentLength, handleToggle: toggleMaxContentLength }, void 0), (0, jsx_runtime_1.jsx)("span", { children: "\uAE00\uC790\uC218 \uC81C\uD55C" }, void 0), hasMaxContentLength && ((0, jsx_runtime_1.jsx)(components_1.InputField, __assign({ "$size": Input_component_1.InputSize.xs, type: "number" }, register("questions.".concat(index, ".maxContentLength"), {
                                required: true,
                                min: 1,
                            })), void 0))] }, void 0)), (0, jsx_runtime_1.jsx)(Styled.IconButton, __assign({ type: "button" }, { children: (0, jsx_runtime_1.jsx)(trash_can_36_svg_1.default, { onClick: function () { return handleRemoveItem(index); } }, void 0) }), void 0), (0, jsx_runtime_1.jsx)(Styled.Divider, {}, void 0), (0, jsx_runtime_1.jsxs)(Styled.RequiredContainer, { children: [(0, jsx_runtime_1.jsx)("span", { children: "\uD544\uC218" }, void 0), (0, jsx_runtime_1.jsx)(components_1.ToggleButtonField, __assign({}, register("questions.".concat(index, ".required"))), void 0)] }, void 0)] }, void 0)] }, void 0));
};
exports.default = ApplicationFormItem;
